import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { StaggerGrid, StaggerItem, MotionDiv } from "../../utils/animations";
import "./home.css";

const TEAM = [
    {
        key: "edwin",
        name: "Edwin Fajardo Murillo",
        initials: "EF",
        accent: "team-card--cyan",
        linkedin: "https://www.linkedin.com/in/edwinfarleyfajardo/",
    },
    {
        key: "raul",
        name: "Raúl Andrés Fajardo Murillo",
        book: {
            title: "«El retorno de los polímatas»",
            url: "https://www.amazon.com/dp/B0H618GF8F",
        },
        initials: "RF",
        accent: "team-card--violet",
        linkedin: "https://www.linkedin.com/in/raulandresfajardo/",
    },
    {
        key: "diego",
        name: "Diego Fernando Nova Arevalo",
        initials: "DN",
        accent: "team-card--teal",
        linkedin: "https://www.linkedin.com/in/diego-nova-data/",
    },
];

function openLinkedIn(url) {
    window.open(url, "_blank", "noopener,noreferrer");
}

function TeamSection() {
    const { t } = useTranslation();
    return (
        <section id="equipo" className="team-section">
            <div className="section-container">
                <MotionDiv className="section-header">
                    <div className="section-tag">{t("team.tag")}</div>
                    <h2 className="section-title">
                        {t("team.title")}
                    </h2>
                    <p className="section-subtitle">
                        {t("team.subtitle")}
                    </p>
                </MotionDiv>

                <StaggerGrid className="team-grid">
                    {TEAM.map((member) => (
                        <StaggerItem key={member.key}>
                            <motion.article
                                className={`team-card ${member.linkedin ? "team-card--clickable" : ""} ${member.accent}`}
                                whileHover={{ y: -6, scale: 1.01 }}
                                transition={{ type: "spring", stiffness: 300, damping: 20 }}
                                role={member.linkedin ? "link" : undefined}
                                tabIndex={member.linkedin ? 0 : undefined}
                                aria-label={member.linkedin ? t("team.viewLinkedinAria", { name: member.name }) : undefined}
                                onClick={member.linkedin ? () => openLinkedIn(member.linkedin) : undefined}
                                onKeyDown={(e) => {
                                    if (member.linkedin && (e.key === "Enter" || e.key === " ")) {
                                        e.preventDefault();
                                        openLinkedIn(member.linkedin);
                                    }
                                }}
                            >
                                <div className="team-card-glow" aria-hidden="true" />
                                <div className="team-avatar">{member.initials}</div>
                                <h3 className="team-name">{member.name}</h3>
                                <p className="team-role">{t(`team.members.${member.key}.role`)}</p>
                                <p className="team-bio">
                                    {t(`team.members.${member.key}.bio`)}
                                    {member.book ? (
                                        <>
                                            {" "}
                                            <a
                                                href={member.book.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="team-book-link"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                {member.book.title}
                                            </a>
                                            .
                                        </>
                                    ) : null}
                                </p>
                                <div className="team-skills">
                                    {t(`team.members.${member.key}.skills`, { returnObjects: true }).map((skill) => (
                                        <span key={skill} className="team-skill-badge">
                                            {skill}
                                        </span>
                                    ))}
                                </div>
                            </motion.article>
                        </StaggerItem>
                    ))}
                </StaggerGrid>
            </div>
        </section>
    );
}

export default TeamSection;
